import useAuth from "~/services/auth/use-auth";
import useAuthTokens from "~/services/auth/use-auth-tokens";

export const useUserIsAuth = () => {
    const { user, isLoaded } = useAuth();
    const { tokensInfoRef } = useAuthTokens();
    const isAuthUser = !!tokensInfoRef.current?.token && !!user?.id && isLoaded;

    return { user, isAuthUser, isLoaded }
};

export default useUserIsAuth
